<div *ngIf="config" class="container-block">

  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">

      <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
        [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
      </app-position-out-config>

      <app-width-height-config [elementChoosing]="objectChoosing" [device]="device" [width]="class['review']['width']"
        (changeWidthHeight)="changeWidthHeight($event)">
      </app-width-height-config>

      <!-- THÔNG SỐ CƠ BẢN -->
      <li nz-submenu [nzTitle]="'thong_so_co_ban' | translate">
        <ul>
          <!-- Định dạng -->
          <li nz-submenu [nzTitle]="'dinh_dang' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
            <!-- Màu nền -->
            <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'review'"
              [elementChoosing]="objectChoosing"
              [config]="config"
              [class]="class"
              [backgroundClass]="class['review']"
              [backgroundConfig]="config['review']"
              [isBlock]="false"
              [id_object]="objectChoosing._id"
              [device]="device"
            >
            </app-background-image-config>
            <div class="mr-2 mb-4 mt-4 view-more" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 7px;
            " *ngIf="config['review'].option_background == 'color'">
              <p class="discover_text" (click)="openViewAll(stylesField[2])"
                style="cursor: pointer; text-align: left; margin: 0">
                {{'mo_rong' | translate}} &#8594;
              </p>
            </div>
            <!-- Khoảng cách giữa các đánh giá -->
            <!-- <div>
              <div class="config-name">
                <p>{{'khoang_cach_giua_cac_đánh giá' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50"
                  [ngModel]="class['main_expansion']['gap'] | vhnumber"
                  (ngModelChange)="class['main_expansion']['gap'] = $event +'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="0" [nzMax]="50" 
                  [ngModel]="class['main_expansion']['gap'] | vhnumber"
                  (ngModelChange)="class['main_expansion']['gap'] = $event +'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </div>  -->
            <!-- Khoảng đệm -->
            <div>
              <app-padding-config
                [objectChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [classPadding]="class['review']"
                [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </li>

          <!-- Thanh cuộn -->
          <li nz-submenu [nzTitle]="'thanh_cuon' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
            <!-- Giới hạn chiều cao để cuộn -->
            <div class="config-name">
              <p>{{'gioi_han_chieu_cao_de_cuon' | translate}}</p>
              <nz-switch [(ngModel)]="config['max_height']"
                (ngModelChange)="updateMaxHeight()">
              </nz-switch>
            </div>
            <!-- Nếu Giới hạn chiều cao để cuộn === true -->
            <ng-container *ngIf="config['max_height']">
              <!-- Chiều cao tối đa -->
              <div>
                <div class="config-name">
                  <p>{{'chieu_cao_toi_da' | translate}}</p>
                  <nz-input-number [nzMin]="50" [nzMax]="1000"
                    [ngModel]="class['review']['max-height'] | vhnumber"
                    (ngModelChange)="class['review']['max-height'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="50" [nzMax]="1000" 
                    [ngModel]="class['review']['max-height'] | vhnumber"
                    (ngModelChange)="class['review']['max-height'] = $event +'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div> 
              <!-- Khoảng cách với scrollbar -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_voi_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="200"
                    [ngModel]="class['review']['padding-right'] | vhnumber"
                    (ngModelChange)="class['review']['padding-right'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="0" [nzMax]="200" 
                    [ngModel]="class['review']['padding-right'] | vhnumber"
                    (ngModelChange)="class['review']['padding-right'] = $event +'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
              <!-- Độ rộng thanh cuộn -->
              <div>
                <div class="config-name">
                  <p>{{'do_rong_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100"
                    [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                    (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="100" 
                    [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
              <!-- Bo góc thanh cuộn -->
              <div>
                <div class="config-name">
                  <p>{{'bo_goc_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100"
                    [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                    (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="100" 
                    [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
              <!-- Màu nền thanh cuộn -->
              <div class="config-name mt-4">
                <p>{{'mau_nen_thanh_cuon' | translate}}</p>
                <div>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['-webkit-scrollbar']['background-color']"
                    [(colorPicker)]="config['-webkit-scrollbar']['background-color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
              </div>
              <!-- Màu thanh cuộn -->
              <div class="config-name mt-4">
                <p>{{'mau_thanh_cuon' | translate}}</p>
                <div>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                    [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
              </div>
            </ng-container>
          </li>

          <!-- CẤU HÌNH VIỀN -->
          <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
            <app-borders-config 
            [elementChoosing]="objectChoosing"
              [id_object]="objectChoosing._id"
              [device]="device" 
              [class]="class" 
              [borderClass]="class['review']">
            </app-borders-config>
          </li>

          <!-- CẤU HÌNH BO TRÒN -->
          <li nz-submenu [nzTitle]="'bo_tron' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
            <app-borders-radius-config 
            [elementChoosing]="objectChoosing"
              [id_object]="objectChoosing._id"
              [device]="device" 
              [class]="class" 
              [borderRadiusClass]="class['review']">
            </app-borders-radius-config>
          </li>

          <!-- CẤU HÌNH ĐỔ BÓNG TỔNG -->
          <li nz-submenu [nzTitle]="'do_bong_tong' | translate" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['review']"
              [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>
          <li nz-submenu [nzTitle]="'noi_dung' | translate" [(nzOpen)]="openMap.menu13" (nzOpenChange)="openHandler('menu13')">
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{'tieu_de' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="objectChoosing.staticdata['text_title_' + functionService.selectedLanguageCode] | vhLanguage : 'text_title' : objectChoosing.component" 
                  (ngModelChange)="objectChoosing.staticdata['text_title_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateStaticdata()"></textarea>
              </mat-form-field>
            </div>
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{'tieu_de_viet_danh_gia_binh_luan' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="objectChoosing.staticdata['text_title_review_' + functionService.selectedLanguageCode] | vhLanguage : 'text_title_review' : objectChoosing.component" 
                  (ngModelChange)="objectChoosing.staticdata['text_title_review_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateStaticdata()"></textarea>
              </mat-form-field>
            </div>
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{'nut_dang_nhap' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="objectChoosing.staticdata['text_button_login_' + functionService.selectedLanguageCode] | vhLanguage : 'text_button_login' : objectChoosing.component" 
                  (ngModelChange)="objectChoosing.staticdata['text_button_login_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateStaticdata()"></textarea>
              </mat-form-field>
            </div>
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{'nut_gui_danh_gia_binh_luan' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="objectChoosing.staticdata['text_button_send_review_' + functionService.selectedLanguageCode] | vhLanguage : 'text_button_send_review' : objectChoosing.component" 
                  (ngModelChange)="objectChoosing.staticdata['text_button_send_review_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateStaticdata()"></textarea>
              </mat-form-field>
            </div>
          </li>
        </ul>
      </li>
      <!-- Chức năng -->
      <li nz-submenu [nzTitle]="'chuc_nang' | translate" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
        <div class="p-1">
          <span>{{'loai_chuc_nang' | translate}}</span>
          <nz-select style="width: 100%; margin-top: 8px" [(ngModel)]="staticdata.review_type" [nzPlaceHolder]="'chon_loai' | translate" (ngModelChange)="onReviewTypeChange($event)">
            <nz-option [nzLabel]="'danh_gia_san_pham' | translate" [nzValue]="'review'"></nz-option>
            <nz-option [nzLabel]="'binh_luan' | translate" [nzValue]="'comment'"></nz-option>
          </nz-select>
        </div>
        <!-- bắt buộc đăng nhập -->
        <div class="p-1">
          <span>{{'bat_buoc_dang_nhap' | translate}}</span>
          <nz-switch [(ngModel)]="staticdata.review_require_login" (ngModelChange)="updateStaticdata()" [nzDisabled]="staticdata.review_type === 'review'"></nz-switch>
        </div>
        <!-- Cấu hình thêm liên kết -->
        <div *ngIf="staticdata.review_require_login" nz-submenu nzTitle="{{'lien_ket_khi_chua_dang_nhap' | translate}}">
          <app-link-page-config [objectChoosing]="objectChoosing"
            [id_object]="objectChoosing._id" [staticdata]="staticdata" [blocks_of_page]="blocks_of_page"
            [dynamic_data]="objectChoosing.dynamic_data" [hasContact]="true">
          </app-link-page-config>
        </div>
      </li>
      <!-- Nút phân trang -->
      <li *ngIf="config.type_display == 'pagination'" nz-submenu nzTitle="{{'nut_phan_trang' | translate}}" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <div class="pl-1" nz-submenu nzTitle="{{'thiet_lap_chung' | translate}}" [(nzOpen)]="openMap.menu10">
          <div class="editor-field">
            <!-- Số lượng đánh giá trên trang -->
            <div class="config-name mb-0">
              <p>{{'so_luong_danh_gia/trang' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="config['rows'] | vhnumber"
                (ngModelChange)="config['rows'] = $event"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <!-- Ẩn nút phân trang -->
            <div class="config-name" style="padding-bottom:5px">
              <div class="title-font">
                {{'an_nut_phan_trang' | translate}}
              </div>
              <nz-switch [(ngModel)]="config['review__pagination']['hide_pagination']" (ngModelChange)="class['review__pagination']['display'] =
                !$event ? 'flex' : 'none';updateConfig();updateClass()"></nz-switch>
            </div>
            <!-- Vị trí cụm nút phân trang -->
            <div>
              <div class="title mb-1 mt-0">{{'vi_tri_cum_nut_phan_trang' | translate}}</div>
              <nz-radio-group style="display:flex; flex-direction:column;"
                [(ngModel)]="class['review__pagination']['justify-content']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="flex-start">{{'trai' | translate}}</label>
                <label nz-radio nzValue="center">{{'giua' | translate}}</label>
                <label nz-radio nzValue="flex-end">{{'phai' | translate}}</label>
              </nz-radio-group>
            </div>
            <!-- Khoảng cách giữa các nút -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['review__pagination-list-button']['gap'] | vhnumber"
                  (ngModelChange)="class['review__pagination-list-button']['gap'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button']['gap'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>

            <!-- Khoảng cách giữa các nút với cột sản phẩm -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut_va_san_pham' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['reviews-list']['padding-bottom'] | vhnumber"
                  (ngModelChange)="class['reviews-list']['padding-bottom'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['reviews-list']['padding-bottom'] | vhnumber"
                (ngModelChange)="class['reviews-list']['padding-bottom'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Chỉnh chiều cao của cụm nút phân trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'chieu_cao_cua_cum_nut_phan_trang' | translate}}</p>
                <nz-input-number [nzMin]="50" [nzMax]="100" [nzStep]="1"
                  [ngModel]="class['review__pagination']['height'] | vhnumber"
                  (ngModelChange)="class['review__pagination']['height'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="50" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['review__pagination']['height'] | vhnumber"
                (ngModelChange)="class['review__pagination']['height'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Ẩn nút biểu tượng-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_bieu_tuong' | translate}}</p>
                <nz-switch [ngModel]="config['icon_pagination']['display']" (ngModelChange)="class['review__pagination-list-button--control']['display'] =
                                  !$event ? 'flex' : 'none'; config['icon_pagination']['display'] = $event"
                  (nzOnAfterChange)="updateConfig();updateClass()"></nz-switch>
              </div>
            </div>
            <!--Ẩn nút Tới trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_toi_trang' | translate}}</p>
                <nz-switch [(ngModel)]="config['goToPage_pagination']['display']"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
            </div>
            <!-- Chọn Font -->
            <div class="d-flex justify-content-between align-items-center">
              <mat-form-field class="w-100">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['review__pagination-list-button']['font-family']"
                  (ngModelChange)="updateClass()">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">
                    {{font.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Thiết lập nút chưa chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chua_chon' | translate}}" [(nzOpen)]="openMap.menu11">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--page-number']['color']"
                [style.background]="class['review__pagination-list-button--page-number']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--page-number']['font-size'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--page-number']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--page-number']['font-size'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--page-number']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--page-number']['border-color']"
                [style.background]="class['review__pagination-list-button--page-number']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--page-number']['border-width'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--page-number']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--page-number']['border-width'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--page-number']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--page-number']['background-color']"
                [style.background]="
                  class['review__pagination-list-button--page-number']['background-color']
                " [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--page-number']['border-radius'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--page-number']['border-radius'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút được chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_duoc_chon' | translate}}" [(nzOpen)]="openMap.menu12">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--active']['color']"
                [style.background]="class['review__pagination-list-button--active']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--active']['font-size'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--active']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--active']['font-size'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--active']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--active']['border-color']"
                [style.background]="class['review__pagination-list-button--active']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--active']['border-width'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--active']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--active']['border-width'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--active']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--active']['background-color']"
                [style.background]="class['review__pagination-list-button--active']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--active']['border-radius'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--active']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--active']['border-radius'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--active']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chuyen_trang' | translate}}" [(nzOpen)]="openMap.menu13">
          <!-- Sử dụng icon -->
          <div class="item mt-3">
            <div class="title-font">{{'su_dung_icon' | translate}}</div>
            <nz-switch [(ngModel)]="config.icon_pagination.icon" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Kiểu icon -->
          <div class="item">
            <div class="title-font">{{'kieu_icon' | translate}}</div>
            <button [disabled]="!config.icon_pagination.icon" nz-button nz-dropdown [nzDropdownMenu]="menu" style="
              width: 50%;
              padding: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            " [nzPlacement]="'bottomCenter'">
              <div style="
                    font-size: 18px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                  ">
                <i [class]="config.icon_pagination.arrow_left_icon"></i>
                <i [class]="config.icon_pagination.arrow_right_icon"></i>
              </div>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let item of bootstrapIconArrows" style="justify-content: center"
                  (click)="onChangeArrows(item)">
                  <div style="
                        font-size: 18px;
                        display: flex;
                        justify-content: space-around;
                        padding: 10px 0px;
                      ">
                    <i [class]="item.icon_left"></i>
                    <i [class]="item.icon_right"></i>
                  </div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="item mt-3">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <div class="item">
            <div class="title-font">{{'truoc' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input [placeholder]="'truoc' | translate"
              [ngModel]="config.content_pagination['content_left_' + functionService.selectedLanguageCode] | vhLanguage : 'content_left' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_left_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <div class="item">
            <div class="title-font">{{'sau' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input [placeholder]="'sau' | translate"
              [ngModel]="config.content_pagination['content_right_' + functionService.selectedLanguageCode] | vhLanguage : 'content_right' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_right_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--control']['background-color']"
                [style.background]="class['review__pagination-list-button--control']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpPositionOffset]="'-200%'" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--control']['color']"
                [style.background]="class['review__pagination-list-button--control']['color']"
                [cpPosition]="'top'" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--control']['font-size'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--control']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--control']['font-size'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--control']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--control']['border-width'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--control']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--control']['border-width'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--control']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">{{'chon_mau_vien' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['review__pagination-list-button--control']['border-color']"
                [style.background]="class['review__pagination-list-button--control']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['review__pagination-list-button--control']['border-radius'] | vhnumber"
                (ngModelChange)="class['review__pagination-list-button--control']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['review__pagination-list-button--control']['border-radius'] | vhnumber"
              (ngModelChange)="class['review__pagination-list-button--control']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div *ngIf="!config['goToPage_pagination']['display']" class="px-1 li-config" nz-submenu
          nzTitle="{{'thiet_lap_nut_toi_trang' | translate}}" [(nzOpen)]="openMap.menu14">

          <div class="item mt-3">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="item">
            <div class="title-font">{{'toi_trang' | translate}}</div>
            <input style="width: 50%" nz-input placeholder="{{'toi_trang' | translate}}"
              [ngModel]="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] | vhLanguage : 'content_goToPage' : objectChoosing.component" 
              (ngModelChange)="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['background_color']"
                [style.background]="config['goToPage_pagination']['background_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">{{'mau_chu' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['color']"  type="button"
                [style.background]="config['goToPage_pagination']['color']" (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">{{'chon_mau_vien' | translate}}</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['border_color']"
                [style.background]="config['goToPage_pagination']['border_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
        </div>
      </li>

      <!-- Bình luận -->
      <li nz-submenu [nzTitle]="'danh_gia' | translate">
        <ul>
          <!-- Định dạng chữ -->
          <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
            <div>
              <div class="config-name">
                <!-- Font-family -->
                <div style="width:65%">
                  <mat-form-field>
                    <mat-label>Font</mat-label>
                    <mat-select [(value)]="class['review-content-text']['font-family']"
                      [(ngModel)]="class['review-content-text']['font-family']" 
                      (nzOnAfterChange)="updateClass()">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Kích thước -->
                <div style="width:35%">
                  <mat-form-field >
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" 
                      [ngModel]="class['review-content-text']['font-size'] | vhnumber"
                      (ngModelChange)="class['review-content-text']['font-size'] = $event + 'px'"
                      (blur)="updateClass()" />
                  </mat-form-field>
                </div>
              </div>
              <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
              <div class="config-font">
                <p class="title-font">{{'kieu_chu' | translate}}</p>
                <div class="field-row">
                  <!-- In đậm -->
                  <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                    [nzType]="class['review-content-text']['font-weight'] == 'bold' ? 'primary': 'default'" 
                    (click)=" class['review-content-text']['font-weight'] = class['review-content-text']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                    <span style="font-weight:500">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                    [nzType]="class['review-content-text']['font-style'] == 'italic'? 'primary': 'default'" 
                    (click)="class['review-content-text']['font-style'] = class['review-content-text']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                    [nzType]="class['review-content-text']['text-decoration'] == 'underline'? 'primary': 'default'" 
                    (click)="class['review-content-text']['text-decoration'] = class['review-content-text']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                    [nzType]="class['review-content-text']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                    (click)="class['review-content-text']['text-transform'] = class['review-content-text']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <div>
                    <input id="color" type="button" 
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                      [cpOKButton]="true" 
                      [(colorPicker)]="class['review-content-text']['color']"
                      [style.background]="class['review-content-text']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
              </div>
              <!-- Canh lề -->
              <div class="my-4">
                <p>{{'canh_le' | translate}}</p>
                <div class="font">
                  <!-- Lề trái -->
                  <button nz-button class="align-button" title="flex-start" 
                    [nzType]="class['review-content-text']['text-align'] === 'left'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['review-content-text']['text-align'] = 'left'; updateClass()">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <!-- Canh giữa -->
                  <button nz-button class="align-button" title="center"
                    [nzType]="class['review-content-text']['text-align'] === 'center'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['review-content-text']['text-align'] = 'center'; updateClass()">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <!-- Lề phải -->
                  <button nz-button class="align-button" title="flex-end"
                    [nzType]="class['review-content-text']['text-align'] === 'right'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['review-content-text']['text-align'] = 'right'; updateClass()">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['review-content-text']['line-height']"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['review-content-text']['line-height']"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <!-- Phản hồi -->
      <li nz-submenu [nzTitle]="'phan_hoi' | translate">
        <ul>
          <!-- Định dạng chữ -->
          <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
            <div>
              <div class="config-name">
                <!-- Font-family -->
                <div style="width:65%">
                  <mat-form-field>
                    <mat-label>Font</mat-label>
                    <mat-select [(value)]="class['response-content']['font-family']"
                      [(ngModel)]="class['response-content']['font-family']" 
                      (nzOnAfterChange)="updateClass()">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Kích thước -->
                <div style="width:35%">
                  <mat-form-field >
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" 
                      [ngModel]="class['response-content']['font-size'] | vhnumber"
                      (ngModelChange)="class['response-content']['font-size'] = $event + 'px'"
                      (blur)="updateClass()" />
                  </mat-form-field>
                </div>
              </div>
              <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
              <div class="config-font">
                <p class="title-font">{{'kieu_chu' | translate}}</p>
                <div class="field-row">
                  <!-- In đậm -->
                  <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                    [nzType]="class['response-content']['font-weight'] == 'bold' ? 'primary': 'default'" 
                    (click)=" class['response-content']['font-weight'] = class['response-content']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                    <span style="font-weight:500">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                    [nzType]="class['response-content']['font-style'] == 'italic'? 'primary': 'default'" 
                    (click)="class['response-content']['font-style'] = class['response-content']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                    [nzType]="class['response-content']['text-decoration'] == 'underline'? 'primary': 'default'" 
                    (click)="class['response-content']['text-decoration'] = class['response-content']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                    [nzType]="class['response-content']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                    (click)="class['response-content']['text-transform'] = class['response-content']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <div>
                    <input id="color" type="button" 
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                      [cpOKButton]="true" 
                      [(colorPicker)]="class['response-content']['color']"
                      [style.background]="class['response-content']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
              </div>
              <!-- Canh lề -->
              <div class="my-4">
                <p>{{'canh_le' | translate}}</p>
                <div class="font">
                  <!-- Lề trái -->
                  <button nz-button class="align-button" title="flex-start" 
                    [nzType]="class['response-content']['text-align'] === 'left'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['response-content']['text-align'] = 'left'; updateClass()">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <!-- Canh giữa -->
                  <button nz-button class="align-button" title="center"
                    [nzType]="class['response-content']['text-align'] === 'center'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['response-content']['text-align'] = 'center'; updateClass()">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <!-- Lề phải -->
                  <button nz-button class="align-button" title="flex-end"
                    [nzType]="class['response-content']['text-align'] === 'right'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['response-content']['text-align'] = 'right'; updateClass()">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['response-content']['line-height']"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['response-content']['line-height']"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="objectChoosing.staticdata"
          [cursorClass]="class['review']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [effectFileUsing]="'review'"
          [elementChoosing]="objectChoosing"
        >
        </app-choose-animations-config>
      </li>
      <!-- ------------------------------ HIỂN THỊ ------------------------------- -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <div class="main-config">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
        [elementChoosing]="objectChoosing"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['review']"
        [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
      <!-- Bo tròn -->
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config
        [elementChoosing]="objectChoosing"
        [staticdata]="staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
      ></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 3">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <ng-container *ngIf="config['background-color']?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color'].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['review']['background-color']"
            type="button" [disabled]="!config['background-color'].gradient_check"
            [style.background]="class['review']['background-color']" (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
          [class.active]="config['background-color']['gradient_direction'] === type.direction"
          [disabled]="!config['background-color'].gradient_check" [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
          "></button>
      </ng-container>
    </div>
  </div>
</div>